export default "__VITE_ASSET__6d7007f5__"